import React from "react";
import { UseFormReturn } from "react-hook-form/dist/types/form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApplicationUpdateApi } from "../../../../../../../../../services/Api/Organization/types";
import { AppState } from "../../../utils/types";
import MultiLocationFormSettings from "./MultiLocationFormSettings";

interface Props {
	appState: AppState;
	form: UseFormReturn<ApplicationUpdateApi>;
}

const MultiLocationForm = ({ appState, form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<>
			<FormInput label={t("lib:common.word.name")} register={register} name="name" errors={errors} />
			<div className={"app-advanced"}>
				<strong>{t("common.word.advanced", { ns: "lib" })}</strong>
			</div>
			<MultiLocationFormSettings form={form} appState={appState} />
		</>
	);
};
export default MultiLocationForm;
